<template>
  <div class="pages">
    <!-- 导航 -->
    <shortcut></shortcut>
    <!-- 导航 -->
    <!-- 头部 -->
    <commonHeader v-if="update"
                  :title="seachText"
                  :selectCode="selectCode"></commonHeader>
    <!-- 头部 -->
    <div class="content">
      <div class="subtitle">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{$t('首页')}}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="cateListNameTop||cateListName||seachText"> <a @click="go()">{{$t('现货库存')}}</a></el-breadcrumb-item>
          <el-breadcrumb-item v-else>{{$t('现货库存')}}</el-breadcrumb-item>

          <el-breadcrumb-item v-if="cateListName&&cateListNameTop"><a @click="cateListGo()">{{cateListNameTop}}</a></el-breadcrumb-item>
          <el-breadcrumb-item v-if="!cateListName&&cateListNameTop">{{cateListNameTop}}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="cateListName">{{cateListName}}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="seachText">{{seachText}}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="cateName">{{cateName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="select"
           v-if="!seachText">
        <div class="block1">
          <div class="l">{{$t('分类')}}:</div>
          <div class="right">
            <div class="list"
                 :class="block1 ? 'o' : ''">
              <div class="item pointer"
                   :class="{addSelect: changeColorTop == i}"
                   @click="selectTop(i,v.id, v.name),cateListNameTop= v.name,cateListName=''"
                   v-for="(v,i) in cateListTop"
                   :key="i"
                   v-show="block1?i<7:i<100">{{ v.name }}</div>
            </div>
          </div>
        </div>
        <div class="block1"
             v-if="changeColorTop!=-1&&cateList.length!=0">
          <div class="l">{{$t('品牌')}}:</div>
          <div class="right">
            <div class="list"
                 :class="block1 ? 'o' : ''">
              <div class="item pointer"
                   :class="{addSelect: changeColor == i}"
                   @click="select(i,v.id, v.name),cateListName= v.name"
                   v-for="(v,i) in cateList"
                   :key="i">{{ v.name }}
              </div>
            </div>
          </div>

        </div>
        <div class="block1"
             v-if="changeColorTop!=-1&&cateListGN.length!=0">
          <div class="l">{{$t('功能')}}:</div>
          <div class="right">
            <div class="datalist"
                 :class="block1 ? 'o' : ''">
              <div class="item pointer"
                   v-for="(v,i) in cateListGN"
                   :key="i">
                <div>{{ v.name }}:</div>
                <div class="mk"
                     :class="{addSelect: v.act == index}"
                     @click="selectNG(item,v,index)"
                     v-for="(item,index) in v.value"
                     :key="index">
                  {{item.name}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="datalist">
        <div class="h">
          <div class="s">
            <span>{{$t('全部商品')}}</span>
            <div class="tag">
              <span><i class="iconfont icon-zhengpinbaozhang2"></i>{{$t('原装正品')}}</span>
              <span><i class="iconfont icon-cangkukucun"></i>{{$t('现货库存')}}</span>
              <span><i class="iconfont icon-043shandian"></i>{{$t('闪电配送')}}</span>
              <span><i class="iconfont icon-tianmaozhengpinbaozhang"></i>{{$t('售后无忧')}}</span>
            </div>
          </div>
          <div>
            {{$t('商品总数')}} : <span class="total">{{total}}</span>
          </div>
        </div>
        <el-empty description=" "
                  image="/static/kong.png"
                  :image-size="550"
                  v-if="selfList.length==0">
          <el-button type="primary"
                     @click="goQQ()"
                     style="width: 90px;height: 60px;margin-left: -10px;margin-top: 20px;"> {{$t('按钮')}}</el-button>
        </el-empty>

        <div class="lists "
             v-else>
          <div class="item"
               v-for="(v,i) in selfList"
               :key="i">
            <el-row type="flex"
                    justify="space-between">
              <el-col :span="3">
                <div class="img"
                     @click="getId(v)">
                  <img :src="$jx.oss(v.image)"
                       alt="">
                </div>
              </el-col>
              <el-col :span="6">
                <div class="info1"
                     @click="getId(v)">
                  <span class="title">{{ v.title }}</span>
                  <span class="desc"> {{$t('供应商型号')}}:{{ v.supplier_name }}</span>
                  <span class="desc"> {{$t('类别')}}:{{v.category.name}}</span>
                  <span class="desc"> {{$t('厂牌')}}:{{ v.brand.name }}</span>
                  <span class="desc miaoshu"> {{$t('描述')}}:{{v.description}}</span>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="info2"
                     @click="getId(v)">
                  <span class="desc"> {{$t('货期:内地 1工作日')}}</span>
                  <span class="desc"> {{$t('批次')}}: <span class="num">{{ v.batch }}</span> </span>
                  <span class="desc"> {{$t('增量')}}:{{ v.increment }}</span>
                  <span class="desc icon pointer"> <i class="iconfont icon-file-pdf"></i>  {{$t('数据手册')}}</span>
                </div>
              </el-col>
              <el-col :span="2">
                <div class="info3"
                     @click="getId(v)">
                  <span class="desc"> {{$t('价格梯度')}}</span>
                  <span v-for="(item,index) in v.price_ladder"
                        :key="index"
                        class="desc num">{{ item.num }}+ </span>
                </div>
              </el-col>
              <el-col :span="2">
                <div class="info4"
                     @click="getId(v)">
                  <span class="desc"> {{$t('价格')}}</span>
                  <span v-for="(item,index) in v.price_ladder"
                        :key="index"
                        class="desc num">{{ item.price }}+ </span>
                </div>
              </el-col>
              <el-col :span="2">
                <div class="info5"
                     @click="getId(v)">
                  <span class="desc"> {{$t('库存')}}</span>
                  <span class="desc">{{ v.stock_num }} </span>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="info6">
                  <div class="desc">
                    <el-input-number size="small"
                                     @change="handleChange(v,v.price_ladder)"
                                     :min="0"
                                     :max="v.stock_num"
                                     v-model="v.GMnum"></el-input-number>
                  </div>
                  <span class="descs"
                        v-if='v.GMprice!=0'> {{$t('合计')}}：<span class="num">¥ {{v.GMprice}}</span></span>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="info7">
                  <span v-on:click.stop="addCar(v)"
                        v-if="v.goodstype!=1&&v.goodstype!=6"
                        class="btn pointer"> {{$t('加入购物车')}}</span>
                  <span v-on:click.stop="getId(v)"
                        class="btn pointer btn_"> {{$t('立即购买')}}</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <el-pagination background
                       @current-change="goPage"
                       :page-size="per_page"
                       layout="prev, pager, next,jumper"
                       :total=total>
        </el-pagination>
      </div>
    </div>

    <foot style="padding-top: 15px;"></foot>

    <el-dialog :visible.sync="Carshow"
               width="20%">
      <div class="tishi"><i class="el-icon-success"
           style="color:#7fc666;font-size: 40px;"></i><span> {{$t('加入购物车成功!')}}</span></div>
      <div class="jiesuan">  {{$t('进入')}}<span @click="goCar"> {{$t('购物车结算')}}</span></div>
    </el-dialog>
  </div>
</template>

<script>
import shortcut from '@/components/shortcut/shortcut.vue';
import foot from '@/components/footer/footer.vue';
export default {

  components: {
    shortcut,
    foot
  },
  data () {
    return {
      cateListName: '',
      cateListNameTop: '',
      seachText: '',
      cateName: '',

      Carshow: false,
      block1: true,
      block2: true,
      cateListTop: [],
      brandList: [],
      cateList: [],
      selfList: '',
      priceList: '',
      ladder: '',
      skuid: '',
      skuNum: '',
      shopId: '',
      shopName: '',
      skuprice: '',
      skumarket_price: '',
      num: 1,
      page: '1',
      changeColor: -1,
      changeColorTop: -1,
      changeBrandColor: 0,
      update: true,

      brand_id: 0,//厂牌ID
      category_id: 0,//分类ID
      brandName: '',
      total: 0,
      per_page: 15,
      selectCode: '0',
      categoryId: '',
      params: '',
      pid: '',
      topId: '-1',
      cateListGN: [],
      gnList: {}
    }
  },
  created () {
    let params = this.$route.params
    this.topId = params.topid
    if (params.title && params.title != '/') {
      this.selectCode = '0'
      if (params.name == '0') {
        this.seachText = params.title
      } else if (params.name && params.name != "-2") {
        this.cateName = params.title
        this.categoryId = params.name
      }
      if (params.pid != '-1') {
        this.pid = params.pid
      }
    }


  },
  mounted () {
    if (this.$route.query.page) {
      console.log(this.$route.query.page)
      // this.page = this.$route.query.page
    }else{
      this.page = 1
      this.getInit()
    }
  },
  computed: {

  },
  beforeDestroy () {

  },
  watch: {
    num: function () {
      this.getSku()
    }
  },
  directives: {

  },

  methods: {
    // qq
    goQQ () {
      let common = JSON.parse(localStorage.getItem('jx:common')).data
      window.open(`http://wpa.qq.com/msgrd?v=1&uin=${common.web_qq}&site=qq&menu=yes`)
    },
    // 点击全部商品
    go () {
      this.cateName = ''
      this.seachText = ''//搜索框内容
      this.cateListNameTop = ''//分类名称
      this.cateListName = ''
      this.category_id = 0//分类ID
      this.changeColor = -1
      this.changeColorTop = -1
      this.update = false
      this.categoryId = ''
      this.pid = ''
      this.topId = ''
      this.$nextTick(() => {
        this.update = true
      })
      this.$router.push(
        { params: { ...this.$route.params, name: -1, title: '/' } }
      )
      this.getInit('1')
    },
    cateListGo () {
      this.pid = ''
      this.changeColor = -1
      this.cateListName = ''
      this.cateName = ''
      this.getInit('1')

    },
    // 点击分类
    selectTop (index, id, name) {
      this.category_id = id
      this.changeColor = -1
      this.pid = ''
      this.topId = id
      this.gnList = {}
      this.categoryId = ''
      this.cateName = ''
      this.$router.push(
        { params: { ...this.$route.params, name: -1, title: '/' } }
      )
      this.getCate(id, false)
      this.getSelf('1')
    },
    // 点击品牌
    select (index, id, name) {
      this.pid = id
      this.cateName = ''
      this.categoryId = ''
      this.getSelf('1')
      this.$router.push(
        { params: { ...this.$route.params, name: '-2', title: name, pid: id, } }
      )
      this.changeColor = index;
    },

    // 请求分类
    getCate (topId, istop) {
      this.$http.get("/wanlshop/Selfsupport/getchild", {
        id: topId
      }).then(res => {
        if (!istop) {
          this.cateList = res.data
          res.data.forEach((it, y) => {
            if (it.id == this.pid) {
              this.changeColor = y
              this.cateListName = it.name
            }
          })
          this.getCate('', true)
        } else {
          this.cateListTop = res.data
          if (this.topId) {
            res.data.forEach((it, y) => {
              if (it.id == this.topId) {
                this.changeColorTop = y
                this.cateListNameTop = it.name
              }
            })
          }
        }
      },
        err => {

        })
      this.$http.get("/wanlshop/common/getattr", {
        id: topId
      }).then(res => {
        if (!istop) {
          res.data.forEach((it, y) => {
            it.act = -1
          })
          this.cateListGN = res.data
          this.getCate('', true)
        }
      },
        err => {

        })
    },

    getInit () {
      this.getCate(this.topId, false)
      this.getSelf('1')
    },
    //  获取数据
    getSelf (page) {
      let filter = {
      }, op = {}, search = ''

      if (this.category_id > 0) {
        filter.category_id = this.category_id
        op.category_id = 'in'
      }
      if (this.seachText) {
        search = this.seachText
      }


      if (this.categoryId) {
        filter['category.id'] = this.categoryId
        op.category = 'in'

      }
      let pam = {
        shop_id: "1",
        page: page,
        goodstype: '',
        pid: this.pid,
        search: search,
        type: 'goods',
        filter: filter,
        op: op
      }
      if (JSON.stringify(this.gnList) != '{}') {
        pam['category_attribute'] = JSON.stringify(this.gnList)
      }

      this.$http.get("/wanlshop/product/lists", pam).then(res => {
        res.data.data.forEach(item => {
          item.GMnum = 0
          item.GMprice = 0
        })
        this.selfList = res.data.data
        this.total = res.data.total
        this.per_page = res.data.per_page
      },
        err => {
        })
    },

    //
    selectNG (item, iv, index) {
      if (iv.act == -1) {
        iv.act = index
        this.gnList[iv.name] = item.name
        this.getSelf('1')
      } else if (iv.act == index) {
        iv.act = '-1'
        delete this.gnList[iv.name]
        this.getSelf('1')
      }
      else if (iv.act != index && iv.act != '-1') {
        iv.act = index
        this.gnList[iv.name] = item.name
        this.getSelf('1')
      }
    },
    // 跳转分页
    goPage (val) {
      this.getSelf(val)
      this.$nextTick(() => {
        window.scroll(0, 0);
      })
    },
    //  详情
    getId (data) {
      if (data.goodstype != 1 && data.goodstype != 6) {
        data = JSON.stringify({ id: data.id })
        let routeData = this.$router.resolve({
          path: `/main/goods/${data}`,
          query: data
        })
        window.open(routeData.href, '_blank')
      }
      if (data.goodstype == 1) {
        this.$router.push({ name: 'seckill' })
      }
      if (data.goodstype == 6) {
        this.$router.push({ name: 'jifeng' })
      }
    },
    // 去购物车
    goCar () {
      this.$router.push({
        path: `/shop/shopCar`,
      })
    },
    // 加入购物车
    addCar (v) {
      this.$jx.IsToken().then((res) => {
        if (res) {
          if (v.GMnum > 0) {
            if (v.is_link == 1) {
              let common = JSON.parse(localStorage.getItem('jx:common')).data
              window.open(`http://wpa.qq.com/msgrd?v=1&uin=${common.web_qq}&site=qq&menu=yes`)
              return
            }
            this.$http.post("/wanlshop/cart/storage", {
              type: "add",
              "data": {
                "price": v.skuprice,//现价
                "market": v.skumarket_price,//市场价
                "shop_id": v.shop_id,
                "shop_name": v.shop.shopname,
                "goods_id": v.id,
                "title": v.title,
                "number": v.GMnum,
                "image": v.image,
                "sku": {
                  "id": v.skuid,
                  "price": v.skuprice,
                  "market_price": v.skumarket_price,
                  "stock": v.stock,
                  "state": v.shop.state,
                  "weigh": v.weigh,
                  "sn": "0000",
                  "sales": v.sales,
                },
                "sku_id": v.skuid,
                "sum": 144
              }
            }).then(res => {
              this.$jx.open1(res.msg)
              this.Carshow = true
              // 移除组件
              this.update = false
              // 在组件移除后，重新渲染组件
              // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
              this.$nextTick(() => {
                this.update = true
              })
            },
              err => {
                console.log(err)
              })
          } else {
            this.$jx.open1('请先选择购买数量')
          }
        } else {
          this.$router.push({ path: '/login/signIn' });
        }
      })
    },
    // 计算
    handleChange (v, arr) {
      arr.forEach((item, i) => {
        if (i == arr.length - 1) {
          if (item.num <= v.GMnum) {
            v.skuid = item.id
            v.skuprice = item.price
            v.skumarket_price = item.market_price
            v.GMprice = (Number(item.price) * v.GMnum).toFixed(2)
          }
        } else {
          if (item.num <= v.GMnum && v.GMnum < arr[i + 1].num) {
            v.skuid = item.id
            v.skuprice = item.price
            v.skumarket_price = item.market_price
            v.GMprice = (Number(item.price) * v.GMnum).toFixed(2)
          }
        }
      })
    },
  },
};

</script>
<style scoped lang="scss">
/deep/ .el-empty__bottom {
  position: absolute;
  opacity: 0;
}
.tishi {
  display: flex;
  align-items: center;
  i {
    margin: 0 20px;
  }
  span {
    font-size: 20px;
  }
}
.jiesuan {
  text-align: center;
  span {
    color: #0094e7;
    cursor: pointer;
  }
}
.addSelect {
  color: #faaf1d !important;
}
.addBrandSelect {
  color: #faaf1d !important;
}
.el-pagination {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 20px;
}

.pages {
  background-color: #fff;
  .header {
    background-color: #fff;

    .block {
      max-width: 1200px;
      min-width: 1200px;
      height: 120px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 80px;
        }

        .cl {
          color: #fff;
          background-color: #0094e7;
          line-height: 36px;
          width: 190px;
          padding: 0 15px;
          font-size: 14px;
          box-sizing: border-box;
          margin-top: 10px;
          font-weight: 600;
        }
      }

      .center {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        flex: 1;
        overflow: hidden;

        .top {
          width: 100%;
          box-sizing: border-box;
          padding: 0 30px;

          .search {
            display: flex;
            justify-content: flex-start;
            padding-left: 50px;

            .blocks {
              display: flex;
              flex-direction: column;

              .hot {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .item {
                  color: #999999;
                  font-size: 12px;
                  margin: 0 4px;

                  &.cur {
                    color: #0094e7;
                  }
                }
              }

              .inputs {
                width: 600px;
                border: 2px solid #0094e7;
                height: 32px;
                display: flex;
                justify-content: space-between;
                margin-right: 20px;
                margin-bottom: 10px;

                select {
                  border: none;
                  outline: none;
                  color: #0094e7;
                  padding: 0 8px;
                  border-right: 1px solid #0094e7;
                }

                input {
                  flex: 1;
                  border: none;
                  outline: none;
                  position: relative;
                  padding: 0 10px;
                  font-size: 14px;
                }

                .ss {
                  width: 50px;
                  background-color: #0094e7;
                  box-sizing: border-box;
                }
              }
            }

            .cart {
              height: 32px;
              line-height: 32px;
              color: #0094e7;
              font-size: 12px;
              border: 1px solid #dddddd;
              padding: 0 30px;
            }
          }
        }

        .tab {
          width: 100%;
          margin-bottom: 4px;
          padding: 0 30px;
          box-sizing: border-box;

          .list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;

            .item {
              white-space: nowrap;
              margin: 0 10px;
              font-size: 16px;
              color: #333333;
              position: relative;

              &:first-child {
                margin-left: 0;
              }

              &:last-child {
                margin-right: 0;
              }

              .t {
                position: absolute;
                background-color: #0094e7;
                color: #fff;
                top: -24px;
                left: 50%;
                transform: translateX(-50%);
                font-size: 12px;
                display: inline-block;
                border-radius: 4px;
                height: 20px;
                line-height: 20px;
                padding: 0 4px;

                &::after {
                  content: "";
                  width: 0;
                  height: 0;
                  border: 5px solid;
                  border-color: #0094e7 transparent transparent transparent;
                  position: absolute;
                  top: 20px;
                  left: 50%;
                  transform: translateX(-50%);
                }
              }
            }
          }
        }
      }
    }
  }

  .content {
    // display: flex;
    // justify-content: center;
    // flex-direction: column;
    min-width: 1200px;
    max-width: 1200px;
    margin: 0 auto;
    background-color: #fff;

    .subtitle {
      font-size: 13px;
      color: #333333;
      margin: 15px 0;
    }

    .select {
      .block1,
      .block2 {
        display: flex;
        justify-content: flex-start;
        border: 1px solid #e6e6e6;
        box-sizing: border-box;

        .l {
          width: 120px;
          background-color: #f4f4f4;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #333333;
          font-size: 14px;
          font-weight: bold;
        }

        .right {
          flex: 1;
          display: flex;
          justify-content: space-between;

          .more {
            white-space: nowrap;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border: 1px solid #dddddd;
            color: #333333;
            font-size: 12px;
            display: inline-flexbox;
            height: 25px;
            line-height: 25px;
            padding: 0 4px;
            margin: 10px 10px 0 0;
          }

          > .list {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            height: 92px;
            overflow: hidden;
            transition: all 2s;

            &.o {
              height: auto;
            }

            .item {
              color: #333333;
              font-size: 15px;
              margin: 10px 30px;
              padding: 4px 10px;
              // border: 1px solid transparent;

              &.cur {
                border-color: #0094e7;
                color: #0094e7;
              }
            }
          }
          .datalist {
            margin: 30px 40px 0;
            overflow: hidden;
            transition: all 2s;
            .item {
              padding-bottom: 30px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              flex-wrap: wrap;
              font-size: 12px;
              div.mk {
                padding-left: 20px;
              }
            }
          }
        }
      }
    }

    .datalist {
      margin-top: 20px;

      .h {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 15px;
        background-color: #f1f1f1;
        border: 1px solid #ccc;
        border-bottom: none;
        .s {
          display: flex;
          justify-content: flex-start;
          > span {
            color: #333333;
            font-size: 16px;
            font-weight: bold;
            margin-right: 10px;
          }

          .tag {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: #ff971d;

            span {
              margin-right: 10px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              font-size: 14px;

              i {
                font-size: 20px;
                margin-right: 4px;
              }
            }
          }
        }
        .total {
          color: #ff971d;
        }
      }

      .lists {
        .item {
          border: 1px solid #cccccc;
          padding: 10px 0;
          margin-bottom: 20px;
          /deep/ .el-row {
            .img {
              padding-left: 10px;
            }
            img {
              width: 100%;
            }
            .miaoshu {
              width: 240px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .info1,
            .info2,
            .info3,
            .info4,
            .info5,
            .info6,
            .info7 {
              display: flex;
              flex-direction: column;
              padding: 0 10px;
              cursor: pointer;
            }

            .title {
              font-size: 20px;
              color: #333333;
              font-weight: bold;
              margin: 10px 0 6px 0;
            }

            .desc {
              color: #666666;
              font-size: 14px;
              padding: 4px 0;
            }

            .icon {
              color: #0094e7;

              span {
                color: #0094e7;
              }
            }

            .num {
              color: #ff6600;
            }

            .info6 {
              padding-top: 10px;

              .descs {
                font-size: 14px;
                padding: 15px 0;
              }
            }

            .info7 {
              padding-top: 10px;
            }

            .btn {
              background-color: #0094e7;
              color: #fff;
              font-size: 16px;
              box-sizing: border-box;
              height: 30px;
              line-height: 30px;
              display: inline-block;
              padding: 0 10px;
              text-align: center;
              margin-bottom: 10px;
            }
            .btn_ {
              background-color: #fff;
              color: #0094e7;
              border: 1px solid #0094e7;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/proprietary/index.vue